import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from '../../shared/statusBadge.component';
import { getHeartbeatStatusMessage, blankLabel } from '../../dashboard/connectionMonitorPage/constants';

export const HeartbeatStatusCellRenderer = ({ value }) => {
  const badgeMessage = getHeartbeatStatusMessage(value);

  return (
    <StatusBadge className="table-badge" value={badgeMessage} />
  );
};
HeartbeatStatusCellRenderer.propTypes = { value: PropTypes.number };

export const HeartbeatStatusFilterCellRenderer = ({ value }) => {
  const badgeMessage = value === null ? blankLabel : getHeartbeatStatusMessage(value);

  return badgeMessage;
};

HeartbeatStatusFilterCellRenderer.propTypes = { value: PropTypes.number };
